import { NameSuggestion, SuggestionKind } from './api'
import { suggestionNamed } from './suggestions'

/**
 * The item forms' side of learning name suggestions (see the backend's
 * LearnedNames, SM-22): which name, if any, saving an item shares, and
 * whether this person shares at all.
 *
 * Only the name, its item type and its category travel — never the amount,
 * dates or notes — and only when the name isn't offered already. Nothing
 * becomes a suggestion until ten people use it and an admin approves it.
 */

/** As the server checks it: letters and a little punctuation, no digits or @. */
const NAME_ALLOWED = /^[\p{L}\p{M}&'’.,+()\- ]{2,80}$/u
const CATEGORY_REFUSED = /[\p{N}@]/u

/** What saving this item would share, or null when there's nothing worth sending. */
export function nameToShare(
  all: NameSuggestion[],
  kind: SuggestionKind,
  name: string,
  category: string,
): NameSuggestion | null {
  const tidy = name.trim().replace(/\s+/g, ' ')
  if (!NAME_ALLOWED.test(tidy) || (tidy.match(/\p{L}/gu) ?? []).length < 2) return null
  if (tidy === 'Untitled' || suggestionNamed(all, kind, tidy)) return null
  const cat = category.trim().replace(/\s+/g, ' ')
  return { kind, name: tidy, category: cat === '' || cat.length > 40 || CATEGORY_REFUSED.test(cat) ? null : cat }
}

const PREFERENCE_KEY = 'snapshot-money:share-item-names'

/** On unless this browser has said no, like sharing merchant names. */
export function sharingPreferred(): boolean {
  try {
    return localStorage.getItem(PREFERENCE_KEY) !== 'no'
  } catch {
    return true
  }
}

export function rememberSharing(on: boolean) {
  try {
    if (on) localStorage.removeItem(PREFERENCE_KEY)
    else localStorage.setItem(PREFERENCE_KEY, 'no')
  } catch {
    // Not remembered; the box is ticked again next time.
  }
}
